module.exports = __webpack_public_path__ + "static/media/E1_REFL.a3cc1e00.png";